// extracted by mini-css-extract-plugin
export default {"doneButton":"Variant_doneButton__YTxAh","tablecellBox":"Variant_tablecellBox__1z2-j","variantAddBtn":"Variant_variantAddBtn__9zQfT"};